import * as React from "react";
import "../../style/fonts.css";
import "./noConnection.css";
import translate from "../../translations/i18n";
import CtaButton from "../ctaButton/ctaButton";
import { Link } from "react-router-dom";
import Message from "../../components/message/message";

class NoConnection extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="NOCONN_CONT">
        <div className="NOCONN_TITLE_CONT">
          <div className="NOCONN_TITLE_CONT_2">
            <div className="TITLE_2">{translate("FAIL_NO_INTERNET_TITLE")}</div>
          </div>
        </div>
        <div className="NOCONN_TEXT_CONT">
          <Message text={translate("FAIL_NO_INTERNET_SUBTITLE")} />
        </div>
        <div className="TRY_AGAIN_CONT">
          <CtaButton
            width={"280px"}
            text={translate("CTA_TRY_AGAIN")}
            color={"white"}
          />
        </div>
      </div>
    );
  }
}

export default NoConnection;



// WEBPACK FOOTER //
// ./src/components/screens/noConnection.tsx